(() => {
  const SKU_SELECTOR = 'hdt-variant-live[is="sku"] span[update-value]';

  function formatSku(rawSku) {
    if (!rawSku) return rawSku;
    return String(rawSku).split('-')[0].trim();
  }

  function applySkuFormatting(root = document) {
    root.querySelectorAll(SKU_SELECTOR).forEach((el) => {
      const original = (el.textContent || '').trim();
      const formatted = formatSku(original);
      if (formatted !== original) el.textContent = formatted;

      if (el.__moxSkuObserver) return;
      const observer = new MutationObserver(() => {
        const nextOriginal = (el.textContent || '').trim();
        const nextFormatted = formatSku(nextOriginal);
        if (nextFormatted !== nextOriginal) el.textContent = nextFormatted;
      });
      observer.observe(el, { childList: true, characterData: true, subtree: true });
      el.__moxSkuObserver = observer;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applySkuFormatting(), { once: true });
  } else {
    applySkuFormatting();
  }

  document.addEventListener('lazyhtml:added', (e) => applySkuFormatting(e.target));
  document.addEventListener('products:update', (e) => applySkuFormatting(e.target));

  const ATC_SELECTOR = '.hdt-product-form__submit, button[name="add"]';

  function shouldBlock() {
    const s = window.themeHDN && window.themeHDN.settings;
    if (!s) return false;
    if (s.customerLoggedIn !== true) return true;
    if (s.customerHasLocation !== true) return true;
    return false;
  }

  function forceDisable(btn) {
    if (!btn) return;
    if (!btn.disabled) btn.disabled = true;
    if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
  }

  function guardAtcButton(btn) {
    if (!btn || btn.__moxAtcGuard) return;
    btn.__moxAtcGuard = true;
    forceDisable(btn);
    const observer = new MutationObserver(() => {
      if (shouldBlock()) forceDisable(btn);
    });
    observer.observe(btn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  }

  function applyAtcGuard(root = document) {
    if (!shouldBlock()) return;
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(ATC_SELECTOR).forEach(guardAtcButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyAtcGuard(), { once: true });
  } else {
    applyAtcGuard();
  }

  document.addEventListener('lazyhtml:added', (e) => applyAtcGuard(e.target));
  document.addEventListener('products:update', (e) => applyAtcGuard(e.target));
  document.addEventListener('variant:update', () => applyAtcGuard());
  document.addEventListener('variant:selected', () => applyAtcGuard());
})();

